import { BusinessInterface } from '@app/models/business';
import {IntegrationType} from "@app/utils/consts.tsx";

export enum ExternalReviewSyncType {
  INITIAL = 'INITIAL',
  AUTO = 'AUTO',
  MANUAL = 'MANUAL',
}

export enum ExternalReviewSyncStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

const STATUS_COLORS: Record<ExternalReviewSyncStatus, string> = {
  [ExternalReviewSyncStatus.PENDING]: 'bg-blue-100 text-blue-800',
  [ExternalReviewSyncStatus.IN_PROGRESS]: 'bg-orange-100 text-orange-800',
  [ExternalReviewSyncStatus.COMPLETED]: 'bg-green-100 text-green-800',
  [ExternalReviewSyncStatus.FAILED]: 'bg-red-100 text-red-800',
};

export const getReviewsSyncStatusColor = (status?: ExternalReviewSyncStatus): string => {
  return status ? STATUS_COLORS[status] : 'bg-gray-100 text-gray-800';
};

const TYPE_COLORS: Record<ExternalReviewSyncType, string> = {
  [ExternalReviewSyncType.INITIAL]: 'bg-green-100 text-green-800',
  [ExternalReviewSyncType.AUTO]: 'bg-blue-100 text-blue-800',
  [ExternalReviewSyncType.MANUAL]: 'bg-purple-100 text-purple-800',
};

export const getReviewsSyncTypeColor = (type?: ExternalReviewSyncType): string => {
  return type ? TYPE_COLORS[type] : 'bg-gray-100 text-gray-800';
};

export interface ReviewsSyncInterface {
  id: string;
  businessId?: string;
  sourceType: IntegrationType;
  type?: ExternalReviewSyncType;
  status?: ExternalReviewSyncStatus;

  reviewsAdded: number;
  reviewsUpdated: number;

  business?: BusinessInterface;
  createdAt: string;
  updatedAt: string;
}
